module.exports = __webpack_public_path__ + "img/add-bank.81425ce8.jpg";